import React from "react";
import { GridColumn, GridRow } from "emotion-flex-grid";
import { useSelector } from "react-redux";
import HeadTitle from "components/HeadTitle";
import Menu from "components/Menu";
import RecipePage from "components/RecipePage";
import { Container, Row, Content } from "styles/General.styled";
import cloudfront from "helpers/cloudfront";
import { RecipeJsonLd } from "next-seo";
import { getAllIngredients, getValidatedPageTitle } from "helpers/checkCollectionDirections";
import Custom404 from "../404";
import { getRecipe } from "store/collectionReducer";

const Recipe = () => {
  const recipe = useSelector(getRecipe);

  if (!recipe.id) {
    return <Custom404 />;
  }

  const ingredients = getAllIngredients(recipe);
  const recipeUserName = recipe.recipe_creator.show_business_name
    ? recipe.recipe_creator.business_name
    : `${recipe.recipe_creator.first_name} ${recipe.recipe_creator.last_name}`;
  const title = getValidatedPageTitle(recipe.title, recipeUserName);

  return (
    <>
      <HeadTitle
        title={title}
        img={cloudfront({ href: recipe.main_image, size: "medium" })}
        description={recipe.description}
      />

      <RecipeJsonLd
        name={recipe.title}
        description={recipe.description}
        datePublished="2018-03-10"
        authorName={[recipeUserName]}
        prepTime={`PT${recipe.active_time}M`}
        cookTime={`PT${recipe.passive_time}M`}
        totalTime={`PT${recipe.passive_time + recipe.active_time}M`}
        keywords="cake for a party, coffee"
        yields={recipe.yields[0].number}
        category="Dessert"
        cuisine="American"
        images={[cloudfront({ href: recipe.main_image, size: "medium" })]}
        ingredients={ingredients}
        instructions={[
          {
            name: "Preheat",
            text: "Preheat the oven to 350 degrees F. Grease and flour a 9x9 inch pan.",
            url: "https://example.com/party-coffee-cake#step1",
            image: "https://example.com/photos/party-coffee-cake/step1.jpg",
          },
        ]}
        aggregateRating={{
          ratingValue: "5",
          ratingCount: "18",
        }}
      />
      <Container>
        <GridColumn pt={["xl1"]} pb={["xl2", "xxl22"]}>
          <Row>
            <Menu />
            <Content>
              <RecipePage recipe={recipe} />
              <GridRow justify={["center"]}>
                <GridColumn width={["100%", "auto"]} ml={["", "auto"]} pt={["m", "l"]} />
              </GridRow>
            </Content>
          </Row>
        </GridColumn>
      </Container>
    </>
  );
};

export default Recipe;
